function assertNonUndefined<T>(value: T | undefined): T {
  if (value === undefined) {
    throw new Error("Value can't be undefined");
  }
  return value;
}

export default assertNonUndefined;
